import type { ManagedPersonDetail } from "#shared/managePeopleContract.ts";

export const PLACEHOLDER_PERSON: ManagedPersonDetail = {
    id: "skeleton",
    displayName: "Xxxxxxx Xxxxxxxx",
    jobTitle: "Xxxxxxx xxxxxxxx",
    roles: ["employee"],
    hireDate: "2024-03-11",
    status: "active",
    lastSessionDate: "2024-09-02",
    firstName: "Xxxxxxx",
    lastName: "Xxxxxxxx",
    preferredName: "Xxxxx",
    employeeId: "Xxxxxxxx",
    dateOfBirth: "1990-06-24",
    pronouns: "Xxx/Xxx",
    email: "xxxxxxx.xxxxxxxx@xxxxxxx.xxx",
    officePhone: "Xxx Xxx Xxxx",
    workLocationLabel: "Xxxxxxxx Xxxxxx",
    timeZone: "Xxxxxxx/Xxxxxxx",
    cityLabel: "Xxxxxxxxx",
    regionLabel: "Xxxxxx",
    countryLabel: "Xxxxxx",
    preferredLanguage: "en-US",
    communicationLanguage: null,
    communicationLanguageOptions: [],
    bio: "Xxxxxxx xxxxx xxxx xxxxxxxxx, xxxx xxxxxx xxxxx xxxxxxx xxxx xxxxxxxxxx xxx xxxxx.",
    interests: [],
    competencies: [],
    isImageLocked: false,
    isFirstNameLocked: false,
    isLastNameLocked: false,
    isEmailLocked: false,
    isGenderLocked: false,
    isPronounsLocked: false,
    isDateOfBirthLocked: false,
    isCityLocked: false,
    isRegionLocked: false,
    isCountryLocked: false,
    isWorkLocationLocked: false,
    isInterestsLocked: false,
    isCompetenciesLocked: false
};
